var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner d-flex text-center"},[_c('h1',{staticClass:"ml-3 mr-3 mt-2"},[_c('span',{staticClass:"text-dark"},[_vm._v("DUNDLE -")]),_vm._v(" YOUR DIGITAL LIFE, MADE EASY")])])
}]

export { render, staticRenderFns }